export * from "./verifyLicense";
